export * from "./verifyLicense";
